<template>
  <div class="user-avatar-dropdown">
    <Poptip :disabled="total < 1" trigger="hover" width="400" placement="bottom">
      <Badge :offset="[14, 0]" style="margin-right: 30px" :count="total" overflow-count="99">
        <Icon :color="total > 0 ? '#2d8cf0' : ''" size="23" type="ios-notifications" @click="openMsg" />
      </Badge>
      <div v-if="total" slot="content">
        <div v-for="(item, index) in tableData" @click="openDetail(item)" :key="index" class="msg-ul">
          <div class="msg-top">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.date }}</div>
          </div>
          <div class="msg-li">{{ item.content }}</div>
        </div>
        <!-- <vxe-table
          :row-config="{ isHover: true }"
          max-height="200"
          :data="tableData"
        >
          <vxe-column
            v-for="item in tableCol"
            :width="item.width"
            :key="item.key"
            :field="item.key"
            :title="$t(item.title)"
            @click="toPage(item.id)"
          ></vxe-column>
        </vxe-table> -->
      </div>
    </Poptip>
    <cTable v-show="false" :methods="methods" :modals="modals" ref="table">
      <!-- 公告详情 -->
      <template #SHOWMSG="{ params, visible }">
        <div style="max-height:60vh;overflow-y:auto;" v-if="visible">
          <List size="small" :split="false">
            <ListItem>
              <ListItemMeta :title="$t('orderNum')" :description="params.airway_number" />
            </ListItem>
            <ListItem>
              <ListItemMeta :title="$t('message') + $t('type')" :description="$t(params.type)" />
            </ListItem>
            <ListItem>
              <ListItemMeta :title="$t('message') + $t('content')" :description="params.content" />
            </ListItem>
            <ListItem>
              <ListItemMeta :title="$t('push') + $t('time')" :description="params.create_time" />
            </ListItem>
          </List>
        </div>
      </template>
    </cTable>
  </div>
</template>

<script>
import cTable from "@/base/common/index";
import { timeFormat } from "@/utils/format";
import {
  getMessageList,
  getMessageDetail,
  updateMessageStatus,
  batchRead
} from "@/api/user";
import { mapState } from "vuex";
export default {
  components: {
    cTable
  },
  name: "badge",
  data() {
    return {
      tableCol: [
        {
          title: "zhTitle",
          key: "title",
          width: "200"
        },
        {
          title: "AssistContent",
          key: "content"
        },
        {
          title: "time",
          key: "date",
          width: "130"
        }
      ],
      tableData: [],
      total: 0,
      methods: {
        getMessageList,
        getMessageDetail,
        updateMessageStatus,
        batchRead
      },
      fields: {},
      modals: {
        msgList: {
          methods: {
            ok({ row, close }) { }
          },
          footer: {
            show: false
          },
          config: {
            title: this.$t("messageList"),
            listFn: "getMessageList",
            modalBind: {
              width: 60,
              styles: {
                top: "7%"
              },
              draggable: true
            }
          },
          table: {
            config: {
              align: "center",
              height: 600
            },
            header: {
              config: {
                custom: false
              },
              searchs: [
                {
                  name: () => this.$t("exlType"),
                  key: "status",
                  component: "Select",
                  placeholder: () => this.$t("select") + this.$t("exlType"),
                  options: [
                    {
                      value: 1,
                      label: this.$t("Read")
                    },
                    {
                      value: 2,
                      label: this.$t("Unread")
                    }
                  ]
                },
                {
                  key: "keywords",
                  placeholder() {
                    return this.$t("keyword");
                  },
                  component: "Input",
                  bind: {
                    type: "textarea",
                    rows: 1
                  },
                  default: this.$route.params.id ? this.$route.params.id : ""
                }
              ],
              btns: {
                list: [
                  {
                    name: () => this.$t("Read"),
                    type: "read",
                    fnName: "read",
                    bind: {
                      type: "primary"
                    },
                    disabled() {
                      return this.getModal('msgList').selectAll.length < 1
                    }
                  }
                ],
                methods: {
                  read({ row }) {
                    let that = this.getModal('msgList')
                    if (!that.selectAll.length) return this.$Message.warning(this.$tz("请选择,订单号"))
                    this.$Modal.confirm({
                      title:
                        this.$t("whether") +
                        this.$t("confirm") +
                        this.$t("Read"),
                      onOk: () => {
                        this.handleRequestMethods(
                          "batchRead",
                          {
                            id: that.selectAll.map(t => t.id),
                          },
                          true,
                          true
                        ).then((res) => {
                          this.$parent.getMsg()
                          that.getList();
                        });
                      },
                    });
                  }
                }
              }
            },
            footer: {
              show: true
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
                fixed: "left"
              },
              {
                name: () => this.$t("orderNum"),
                key: "feedback_number",
                width: 150,
                copy: true,
                header: {
                  copy: true
                }
              },
              {
                name: () => this.$t("businessTypes"),
                key: "type",
                tooltip: true,
                minWidth: 80,
                methods: {
                  render: ({ value }) => {
                    return this.$t(value);
                  }
                }
              },
              {
                name: () => this.$t("zhTitle"),
                key: "title",
                minWidth: 130
              },
              {
                name: () => this.$t("content"),
                key: "content",
                minWidth: 200
              },
              {
                name: () => this.$t("exlType"),
                key: "status",
                width: 100,
                methods: {
                  render: ({ value }) => {
                    return value == 2 ? this.$t("Unread") : this.$t("Read");
                  }
                },
                render: (h, p) => {
                  return h(
                    "span",
                    {
                      style: {
                        color: p.row.status == 2 ? "#ed4014" : "#19be6b"
                      }
                    },
                    p.row.status == 2 ? this.$t("Unread") : this.$t("Read")
                  );
                }
              },
              {
                name: () => this.$t("pushed_time"),
                key: "date",
                width: 150
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 150,
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "detail",
                    fnName: "detailFun",
                    bind: {
                      type: "primary"
                    }
                  }
                ],
                methods: {
                  detailFun: ({ row }) => {
                    this.getMsgDetail(this.$refs["table"], row);
                  }
                }
              }
            ]
          }
        },
        show: {
          contentSlot: "SHOWMSG",
          config: {
            listFn: "list",
            modalBind: {
              width: "550",
              draggable: true,
              sticky: true,
              scrollable: true,
              "class-name": "bulletin-tit"
            }
          },
          methods: {
            ok({ row, close }) {
              this.close();
              this.$page.getModal("msgList").open(null, function (params) {
                this.getList();
              });
            },
            cancel({ row, close }) {
              if (row.isUpdate) this.$page.getModal("msgList").getList();
            }
          },
          footer: {
            ok: {
              name: () => this.$t("return_t") + this.$t("messageList")
            },
            cancel: {
              name: () => this.$t("close")
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapState({
      remind: state => state.app.remind
    })
  },
  watch: {
    $route() {
      this.getMsg();
    },
    remind(newVal) {
      if (newVal) {
        this.getMsg();
        this.$store.commit("remindFun", false);
      }
    }
  },
  created() {
    this.getMsg();
  },
  methods: {
    // 获取消息详情
    getMsgDetail(that, row, isHide) {
      that
        .handleRequestMethods("getMessageDetail", row.id, false, true)
        .then(res => {
          if (row.status == 2) {
            res.payload["isUpdate"] = true;
            updateMessageStatus(row.id).then(res => {
              if (res.data.status) {
                this.getMsg();
              }
            });
          }
          res.payload.create_time = that.format.timeFormat(
            res.payload.create_time * 1000,
            "YYYY-MM-DD HH:mm:ss"
          );
          if (isHide) res.payload["isUpdate"] = false;
          that.getModal("show").open(res.payload, function () {
            this.setTitle(row.title);
            if (!isHide) {
              this.footer_hide = true;
            } else {
              this.footer_hide = false;
            }
          });
        });
    },
    openMsg() {
      this.$refs.table.getModal("msgList").open(null, function () {
        this.getList();
      });
    },
    getMsg() {
      getMessageList({ status: 2 }).then(res => {
        if (res.data.status) {
          this.tableData = res.data.payload.rows;
          this.total = res.data.payload.total;
        }
      });
    },
    openDetail(row) {
      this.getMsgDetail(this.$refs["table"], row, true);
    }
    // toPage(name, id) {
    //   // let name = "assistPlatform";
    //   if (
    //     (this.$route.name == "assistPlatform" && name == "assistPlatform") ||
    //     (this.$route.name == "claim_list" && name == "claim_list")
    //   ) {
    //     this.$store.commit("remindIdFun", id);
    //   } else {
    //     this.$router.push({
    //       params: { id },
    //       name
    //     });
    //   }
    // }
  }
};
</script>
<style lang="less" scoped>
.msg-ul {
  width: 100%;
  border-bottom: 1px solid #f3f3f3;
  padding: 5px;

  .msg-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      width: 200px;
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }

    // border-bottom: 1px solid #f5f5f5;
  }

  .msg-li {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
}
</style>
